module.exports = __webpack_public_path__ + "static/media/aviatrix.6c81aa17.svg";